<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
-->

<gh-ext-page>
  <gh-ext-page-title title="{{'lbl_invoices' | translate}}"></gh-ext-page-title>
  <gh-ext-page-content>
    <gh-ext-uploader label="lbl_upload_invoice" url="/invoices" accept="image/png,image/jpeg,image/jpg,application/pdf" maxSize="10mb" (invalid)="onUploadError($event)" (success)="onUploadSuccess()">
    </gh-ext-uploader>
    <ng-container matSort="">
      <!-- Desktop version -->
      <mat-table *ghExtIfQuery="'gt-sm'" ghExtInfiniteTable="" [dataSource]="dataSource" [tracker]="tracker" [trackBy]="getInvoiceId">
        <ng-container matColumnDef="fileName">
          <mat-header-cell fxFlex="55%" *matHeaderCellDef="" mat-sort-header="">{{'lbl_file_name' | translate}}</mat-header-cell>
          <mat-cell fxFlex="55%" *matCellDef="let invoice">{{ invoice.fileName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="updatedDate">
          <mat-header-cell fxFlex="15%" *matHeaderCellDef="" mat-sort-header="">{{'lbl_uploaded_date' | translate}}</mat-header-cell>
          <mat-cell fxFlex="15%" *matCellDef="let invoice">{{ invoice.updatedDate | typeFormat:'ShortDate' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef=""></mat-header-cell>
          <mat-cell *matCellDef="let invoice" class="cell-align-right">
            <button type="button" class="small cell-button" color="primary" mat-flat-button="" (click)="delete(invoice)">{{'lbl_delete' | translate}}</button>

            <button type="button" class="small cell-button" mat-stroked-button="" (click)="view(invoice)">{{'lbl_view' | translate}}</button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let invoice; columns: displayedColumns" [ghExtInfiniteRow]="invoice"></mat-row>
      </mat-table>

      <!-- Mobile version -->
      <div *ghExtIfQuery="'lt-md'" fxLayout="column">
        <gh-ext-infinite-list [itemHeight]="170" [tracker]="tracker">
          <mat-card *ghExtInfiniteScrollFor="let invoice of dataSource">
            <mat-card-content>
              <div class="card-content-item">
                <div class="card-content-item-title">{{'lbl_file_name' | translate}}</div>
                <div class="card-content-item-value">{{ invoice.fileName }}</div>
              </div>
              <div class="card-content-item full-width">
                <div class="card-content-item-title">{{'lbl_uploaded_date' | translate}}</div>
                <div class="card-content-item-value">{{ invoice.updatedDate | typeFormat:'ShortDate' }}</div>
              </div>
            </mat-card-content>
            <mat-card-actions>
              <button type="button" class="small cell-button" color="primary" mat-flat-button="" (click)="delete(invoice)">{{'lbl_delete' | translate}}</button>

              <button type="button" class="small cell-button" mat-stroked-button="" (click)="view(invoice)">{{'lbl_view' | translate}}</button>
            </mat-card-actions>
          </mat-card>
        </gh-ext-infinite-list>
      </div>
      <gh-ext-load-tracker fxFlex="" #tracker="ghExtLoadTracker"></gh-ext-load-tracker>
    </ng-container>
  </gh-ext-page-content>
</gh-ext-page>